import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import WebFont from "webfontloader";
import { selectLandingFonts } from "../redux/slices/landingSlice";
import useTemplateStyles from "./useTemplateStyles";

export default function useCustomFonts() {
  const [loadedBanner, setLoadedBanner] = useState<boolean>(false);
  const [loadedFont, setLoadedFont] = useState<boolean>(false);
  const [loadedText, setLoadedText] = useState<boolean>(false);
  const [loadedLandingFonts, setLoadedLandingFonts] = useState<boolean>(false);

  const landingFonts = useSelector(selectLandingFonts);

  const { titleStyles, bannerFontFamily } = useTemplateStyles();

  useEffect(() => {
    const getFamilies = (): string[] => {
      const res: string[] = [];
      if (!loadedBanner && bannerFontFamily) {
        setLoadedBanner(true);
        res.push(bannerFontFamily);
      }
      if (!loadedFont && titleStyles?.fontFamily) {
        setLoadedFont(true);
        res.push(titleStyles?.fontFamily);
      }
      if (!loadedText && titleStyles?.textFontFamily) {
        setLoadedText(true);
        res.push(titleStyles?.textFontFamily);
      }
      if (!loadedLandingFonts && (landingFonts ?? []).length > 0) {
        setLoadedLandingFonts(true);
        res.push(...landingFonts);
      }
      return res;
    };

    const families = getFamilies();
    if (families.length > 0) {
      WebFont.load({
        custom: {
          families,
          urls: [`https://cleverlynk-fonts.s3.amazonaws.com/FontImports.css`],
        },
        google: {
          families,
        },
      });
    }
  }, [bannerFontFamily, titleStyles, landingFonts]);
}
